import type { PaymentOption } from '@src/domains/payments/types/payment';

type Input = {
  paymentOption?: PaymentOption;
  phoneVerifiedAt?: string | null;
};

export const needsPhoneVerification = ({ paymentOption, phoneVerifiedAt }: Input): boolean =>
  Boolean(paymentOption?.needsPhoneVerification && !phoneVerifiedAt);
